export const videoSrcBuildersHash = {
  youtube: async (videoId) => `https://www.youtube.com/embed/${videoId}?rel=0&showinfo=0&autoplay=0`,
  vimeo: async (videoId) => `https://player.vimeo.com/video/${videoId}?title=0&byline=0&autoplay=false`,
  ok: async (videoId) => `https://ok.ru/videoembed/${videoId}?nochat=1&autoplay=0`,
  vk: async (videoId) => {
    const [oid, id] = videoId.split('_');
    return `https://vkvideo.ru/video_ext.php?oid=${oid}&id=${id}`;
  }
};
